import Config from "react-global-configuration"

export const checkIsUrl = (href) => {
  try {
    const url = new URL(href)
    return !!url
  } catch (err) {
    return false
  }
}

export const isInternalLink = (href) => {
  if (!href || typeof href !== "string") {
    return false
  }

  const {
    links: { domains }
  } = Config.get()

  try {
    // Handle relative URLs (they are internal by definition)
    if (href.startsWith("/") || href.startsWith("./") || href.startsWith("../")) {
      return true
    }

    // Handle URLs without protocol
    let urlToCheck = href
    if (!href.startsWith("http://") && !href.startsWith("https://")) {
      urlToCheck = `https://${href}`
    }

    const url = new URL(urlToCheck)
    const hostname = url.hostname.toLowerCase()

    // Check if the hostname matches any of our internal domains
    return domains.some((domain) => {
      const domainLower = domain.toLowerCase()
      // Exact match or subdomain match
      return hostname === domainLower || hostname.endsWith(`.${domainLower}`)
    })
  } catch (error) {
    // If URL parsing fails, fall back to the original includes check
    // This handles edge cases where the URL might not be perfectly formatted
    return domains.some((domain) => href.toLowerCase().includes(domain.toLowerCase()))
  }
}

export const replaceDomainWithCurrentDomain = (href) => {
  const { host } = window.location
  const cleanHref = href.replace(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n]+)(?::\d+)?/im, "")
  return `https://${host}${cleanHref}`
}

export const convertToValidUrl = (href) => {
  if (!href || typeof href !== "string") {
    return href
  }

  const trimmedHref = href.trim()

  // If it already has a protocol, return as is
  const lowercaseHref = trimmedHref.toLowerCase() // <- use this for our checks
  if (lowercaseHref.startsWith("http://") || lowercaseHref.startsWith("https://")) {
    return trimmedHref
  }

  // If it's a relative URL, return as is
  if (trimmedHref.startsWith("/") || trimmedHref.startsWith("./") || trimmedHref.startsWith("../")) {
    return trimmedHref
  }

  // Add https:// protocol to URLs without protocol
  return `https://${trimmedHref}`
}

// URL regex pattern for detecting URLs in text
export const URL_REGEX = /((?:https?:\/\/)?(?:[\w-]+\.)+[\w-]{2,}(?::\d+)?(?:\/\S*)?)/gi

// Check if a string matches URL pattern (more lenient than checkIsUrl)
export const matchesUrlPattern = (text) => {
  if (!text || typeof text !== "string") {
    return false
  }
  const regex = new RegExp(URL_REGEX.source, "gi")
  return regex.test(text)
}

// strips the domain from the URL, returning only the path, query, and hash
// useful when using NavLink for internal links
export const stripDomainFromUrl = (href) => {
  if (!href || typeof href !== "string") {
    return href
  }
  if (href.startsWith("/")) {
    return href
  }
  // remove the domain from the url
  try {
    const urlObj = new URL(href, window.location.origin)
    return urlObj.pathname + urlObj.search + urlObj.hash
  } catch (err) {
    // fallback: return original href if parsing fails
    return href
  }
}
